export const removeLoadingState = () => {
  $("body > .landing-loader").detach();
  $("#react_app").show();
  $("#app").show();

  $("#app").css("display", "block");
  $("body").addClass("body-loaded");
};
